import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-img',
  templateUrl: './img.component.html',
  styleUrls: ['./img.component.scss'],
})
export class ImgComponent implements OnInit {

  @Input() set src(_src:string) {
    this.lightSrc = _src;
    this.darkSrc = _src.replace(/(.*)(.png|.svg)/, '$1-dark$2');
  }
  get src() { return this.lightSrc }

  darkSrc;
  lightSrc;

  constructor() { }

  ngOnInit() {}
}
